import React, { FC } from 'react'
import PageLayout from 'layouts/PageLayout'
import { ErrorMessage } from '@sketch/components'
import EmptyHeader from 'containers/EmptyHeader'
import styled from 'styled-components'
import { ReactComponent as WarningTriangle } from '@sketch/icons/warning-triangle-64-svg'

const StyledErrorMessage = styled(ErrorMessage)`
  flex: 1 0 auto;
`

type EmbeddedErrorPageProps = {
  for: 'document' | 'artboard' | 'unknown'
}

/**
 * A simple error view for embeds that fail to load.
 */
const EmbeddedErrorPage: FC<EmbeddedErrorPageProps> = props => {
  const title = {
    document: "We couldn't find the document.",
    artboard: "We couldn't find the artboard.",
    unknown: 'There was an error loading this content.',
  }[props.for]

  const message =
    props.for === 'unknown' ? null : 'It may have been moved or deleted.'

  return (
    <PageLayout header={<EmptyHeader />}>
      <StyledErrorMessage
        icon={<WarningTriangle />}
        iconSize="medium"
        title={title}
      >
        {message}
      </StyledErrorMessage>
    </PageLayout>
  )
}

export { EmbeddedErrorPage }
